// @flow
import type { State } from 'store/State';
import { createSelector } from 'reselect';

// Selectors
import { getQueryParam } from 'store/reducers/queryParams/selectors';
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';
import { getVehicle } from 'store/reducers/appointment/selectors';
import { getPersonInfo } from 'store/reducers/user/personInfo/selectors';
import { getActivePromotion } from 'store/reducers/promotions/selectors';

// Utils
import { isTrue } from 'utils/varValidation';

type marketingObject = {
  vin: string,
  sab?: string
};

type optStatusObject = {
  MARKETING: string | boolean
};

type optInUrlObject = {
  MARKETING?: ?string | boolean,
  urlOptIn: string
};

export const marketingSelector = (state: State): marketingObject =>
  state.marketing;

export const getMarketingSAB = createSelector(
  [marketingSelector],
  (marketing: marketingObject): string | void => {
    if (marketing && marketing.sab) {
      return marketing.sab;
    }
  }
);

export const isPromotionEnabled = createSelector(
  getPolicyProperty,
  getVehicle,
  getPersonInfo,
  getQueryParam('vin'),
  getQueryParam('extId'),
  getActivePromotion,
  (getPolicyPropertyFn, vehicle, personInfo, vin, extId, activePromotion) => {
    let valid = false;
    if (activePromotion) {
      return true;
    }
    if (isTrue(getPolicyPropertyFn('mk7Enabled'))) {
      if (vehicle && vehicle.vin && personInfo && personInfo.extId) {
        valid = true;
      }
      if (vin && extId) {
        valid = true;
      }
    }
    return valid;
  }
);

export const getOptStatus = createSelector(
  [marketingSelector],
  (optStatus: optStatusObject): string | boolean => {
    if (optStatus && optStatus.MARKETING) {
      return optStatus.MARKETING;
    }
    return '';
  }
);

export const getOptInUrlSelector = createSelector(
  [marketingSelector],
  (optInUrl: optInUrlObject): string | null => {
    return optInUrl && optInUrl.urlOptIn ? optInUrl.urlOptIn : null;
  }
);

export const getDefaultPromo = createSelector(
  marketingSelector,
  ({ isDefaultPromotionSet }): boolean => {
    return isDefaultPromotionSet;
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/marketing/selectors.js